import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import {
    renderField,
    renderCheckbox,
    required,
    renderTextArea,
    json,
    number,
    positive_float, renderPassTextArea, renderPass
} from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Collapse, Alert } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import { getAutoScaleConfigs } from "../../../actions/actionAutoScale";
import { getLicenseStatus } from "../../../actions/actionFooter";
import { getZones } from "../../../actions/actionZones";
import { getServerPools } from "../../../actions/actionServerPool";
import { getVmProviderConfigs } from "../../../actions/actionVmProvider";
import { getDnsProviderConfigs } from "../../../actions/actionDnsProvider";
import { getLdap } from "../../../actions/actionLdap";
import ServerPoolForm from "../../ServerPools/ServerPoolForm/ServerPoolForm";
import { createServerPool } from "../../../actions/actionServerPool";


import SelectInput from "../../../components/SelectInput";
import VmProviderConfigFormTemplate from "../../VmProvider/VmProviderConfigForm/VmProviderConfigForm";
import DnsProviderConfigFormTemplate from "../../DnsProvider/DnsProviderConfigForm/DnsProviderConfigForm";


class AutoScaleConfigFormTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentAutoScaleConfig: {},
            collapseAdvanced: false,
            licensed: false,
            vmProviderModal: false,
            dnsProviderModal: false,
            serverPoolModal: false,
            disableMaxPerServer: false,
            pool: new URLSearchParams(this.props.location.search).get('pool') || null,
        };
        this.changeDnsProvider = this.changeDnsProvider.bind(this);
        this.changeServerPool = this.changeServerPool.bind(this);
        this.toggleServerPoolModal = this.toggleServerPoolModal.bind(this);
        this.cancelServerPoolModal = this.cancelServerPoolModal.bind(this);
        this.toggleVmProviderModal = this.toggleVmProviderModal.bind(this);
        this.cancelVmProviderModal = this.cancelVmProviderModal.bind(this);
        this.toggleDnsProviderModal = this.toggleDnsProviderModal.bind(this);
        this.cancelDnsProviderModal = this.cancelDnsProviderModal.bind(this);
        this.updateVmProvider = this.updateVmProvider.bind(this);
        this.updateDnsProvider = this.updateDnsProvider.bind(this);
        this.updateServerPool = this.updateServerPool.bind(this);
        this.initialize = this.initialize.bind(this);
        this.connection_type = this.connection_type.bind(this);
    }

    connection_type(type) {
        if (type === 'KasmVNC') {
            this.setState({ disableMaxPerServer: true })
            this.props.change('max_simultaneous_sessions_per_server', 1);
        }
        if (type === 'RDP') {
            this.setState({ disableMaxPerServer: false })
        }
    }

    changeServerPool(provider) {
        if (provider === 'new_pool') {
            this.setState({ serverPoolModal: true })
        }
    }

    toggleServerPoolModal() {
        this.setState({
            serverPoolModal: !this.state.serverPoolModal
        });
        if (this.state.serverPoolModal === true) {
            this.props.change('server_pool_id', null);
        }
    }
    cancelServerPoolModal() {
        this.setState({
            serverPoolModal: false
        });
        this.props.change('server_pool_id', null);
    }

    toggleVmProviderModal() {
        this.setState({
            vmProviderModal: !this.state.vmProviderModal
        });
        if (this.state.vmProviderModal === true) {
            this.props.change('vm_provider_config_id', null);
        }
    }
    cancelVmProviderModal() {
        this.setState({
            vmProviderModal: false
        });
        this.props.change('vm_provider_config_id', null);
    }

    changeDnsProvider(provider) {
        if (provider === 'new_provider') {
            this.setState({ dnsProviderModal: true })
        }
    }

    toggleDnsProviderModal() {
        this.setState({
            dnsProviderModal: !this.state.dnsProviderModal
        });
        if (this.state.dnsProviderModal === true) {
            this.props.change('dns_provider_config_id', null);
        }
    }
    cancelDnsProviderModal() {
        this.setState({
            dnsProviderModal: false
        });
        this.props.change('dns_provider_config_id', null);
    }



    cancelButton() {
        if (this.state.pool !== null) {
            this.props.history.push("/update_server_pool/" + this.state.pool);
        } else {
            this.props.history.push("/autoscale");
        }
    }


    initialize(config) {
        this.props.initialize({
            autoscale_config_name: config.autoscale_config_name,
            autoscale_type: config.autoscale_type,
            enabled: config.enabled,
            zone_id: config.zone_id,
            standby_cores: config.standby_cores,
            standby_memory_mb: config.standby_memory_mb,
            standby_gpus: config.standby_gpus,
            downscale_backoff: config.downscale_backoff,
            register_dns: config.register_dns,
            base_domain_name: config.base_domain_name,
            nginx_cert: config.nginx_cert,
            nginx_key: config.nginx_key,
            agent_cores_override: config.agent_cores_override,
            agent_memory_override_gb: config.agent_memory_override_gb,
            agent_gpus_override: config.agent_gpus_override,
            connection_type: config.connection_type,
            connection_info: config.connection_info ? JSON.stringify(config.connection_info, null, 2) : null,
            connection_port: config.connection_port,
            connection_username: config.connection_username,
            connection_password: config.connection_password,
            reusable: config.reusable,
            reusable: config.reusable,
            hooks: config.hooks ? JSON.stringify(config.hooks, null, 2) : null,
            minimum_pool_standby_sessions: config.minimum_pool_standby_sessions,
            max_simultaneous_sessions_per_server: config.max_simultaneous_sessions_per_server,
            vm_provider_config_id: config.vm_provider_config_id,
            dns_provider_config_id: config.dns_provider_config_id,
            server_pool_id: config.server_pool_id,
            ad_create_machine_record: config.ad_create_machine_record,
            ad_computer_container_dn: config.ad_computer_container_dn,
            ldap_id: config.ldap_id,

        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.autoscale_configs && nextProps.autoscale_configs.length > 0 && this.props.autoscale_configs !== nextProps.autoscale_configs && this.props.getAutoScaleLoading && this.props.fromUpdate) {
            let currentAutoScaleConfig = nextProps.autoscale_configs.find(autoscale => autoscale.autoscale_config_id === this.props.autoscaleConfigId);
            this.setState({ currentAutoScaleConfig: currentAutoScaleConfig });
            this.initialize(currentAutoScaleConfig)
            if (currentAutoScaleConfig.connection_type === 'KasmVNC') {
                this.setState({ disableMaxPerServer: true });
            }

        }
        if (nextProps.license_info && nextProps.license_info !== this.props.license_info) {
            this.setState({ licensed: nextProps.license_info.status.features.indexOf('auto_scaling') >= 0 });
        }
    }

    async componentDidMount() {
        if (this.props.fromUpdate) {
            this.props.getAutoScaleConfigs();
        }
        this.props.getZones()
        this.props.getVmProviderConfigs()
        this.props.getDnsProviderConfigs()
        this.props.getLdap()
        const { license_info } = this.props;
        if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('auto_scaling') >= 0) {
            this.setState({ licensed: true });
        }
        try {
            await this.props.getServerPools()
            if (this.props.server_pools.length > 0 && this.state.pool !== null) {
                const pool_details = this.props.server_pools.find(pool => pool.server_pool_id === this.state.pool)
                this.props.change('server_pool_id', this.state.pool);
                this.props.change('autoscale_type', pool_details.server_pool_type);
                this.props.onTypeChange(pool_details.server_pool_type)
            }
        } catch (e) {

        }
        if (this.props.autoscale_config) {
            this.initialize(this.props.autoscale_config)
        }
    }

    updateVmProvider(data) {
        this.props.getVmProviderConfigs()
        this.props.change('vm_provider_config_id', data.vm_provider_config_id);
        this.setState({
            vmProviderModal: false
        });
    }

    updateDnsProvider(data) {
        this.props.getDnsProviderConfigs()
        this.props.change('dns_provider_config_id', data.dns_provider_config_id);
        this.setState({
            dnsProviderModal: false
        });
    }
    updateServerPool(data) {
        this.props.getServerPools()
        this.props.change('server_pool_id', data.server_pool_id);
        this.setState({
            serverPoolModal: false
        });
    }

    render() {
        const { handleSubmit, autoscaleFormValues, zones, server_pools, vm_provider_configs, dns_provider_configs,
            ldap_configs } = this.props;
        if (!this.state.licensed) {
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href={license_url}>More Information</a><br />
                </Alert>
            )
        }

        let optionsZones = [];
        zones.map(opt => {
            optionsZones.push({ label: opt.zone_name, value: opt.zone_id, zone_name: opt.zone_name });
        });
        optionsZones.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionsAutoScaleTypes = [
            { value: 'Docker Agent', label: 'Docker Agent' },
            { value: 'Server Pool', label: 'Server' }
        ]

        let optionServerPools = [];
        server_pools.map(opt => {
            optionServerPools.push({ label: opt.server_pool_name, value: opt.server_pool_id });
        });
        optionServerPools.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionDnsProviders = [];
        dns_provider_configs.map(opt => {
            optionDnsProviders.push({ label: opt.dns_provider_config_name, value: opt.dns_provider_config_id });
        });
        optionDnsProviders.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);

        let optionsConnectionTypes = [
            { value: 'KasmVNC', label: 'KasmVNC' },
            { value: 'RDP', label: 'RDP' }
        ]


        let optionsLdapConfigs = [];
        ldap_configs.map(opt => {
            optionsLdapConfigs.push({ label: opt.name, value: opt.ldap_id });
        });
        optionsLdapConfigs.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase()) ? 1 : -1);


        return (
            <Form onSubmit={handleSubmit}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="autoscale_config_name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="autoscale_config_name"
                                    id="autoscale_config_name"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="server_id" className="requiredasterisk">AutoScale Type</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="autoscale_type"
                                    selectedValue={autoscaleFormValues && autoscaleFormValues.autoscale_type ? autoscaleFormValues.autoscale_type : ""}
                                    onOptionChange={this.props.onTypeChange}
                                    options={optionsAutoScaleTypes}
                                    isUpdateForm={this.props.fromUpdate}
                                    validate={required}
                                    disabled={this.state.pool !== null || this.props.fromUpdate}
                                    component={SelectInput} />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="server_pool_id" className="requiredasterisk">Pool</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="server_pool_id"
                                    selectedValue={autoscaleFormValues && autoscaleFormValues.server_pool_id}
                                    options={optionServerPools}
                                    isUpdateForm={this.props.fromUpdate}
                                    onOptionChange={this.changeServerPool}
                                    validate={required}
                                    disabled={this.state.pool !== null || this.props.fromUpdate}
                                    component={SelectInput} />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="enabled">Enabled </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="checkbox"
                                    name="enabled"
                                    id="enabled"
                                    checked={autoscaleFormValues && autoscaleFormValues.enabled}
                                    component={renderCheckbox}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="zone_id" className="requiredasterisk">Deployment Zone</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field name="zone_id"
                                    selectedValue={autoscaleFormValues && autoscaleFormValues.zone_id ? autoscaleFormValues.zone_id : ""}
                                    options={optionsZones}
                                    isUpdateForm={this.props.fromUpdate}
                                    validate={required}
                                    component={SelectInput} />
                            </Col>
                        </Row>
                    </FormGroup>
                    {autoscaleFormValues && autoscaleFormValues.autoscale_type === "Server Pool" && (
                        <React.Fragment>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="connection_type" className="requiredasterisk">Connection Type </Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field name="connection_type"
                                            selectedValue={autoscaleFormValues && autoscaleFormValues.connection_type ? autoscaleFormValues.connection_type : ""}
                                            options={optionsConnectionTypes}
                                            validate={required}
                                            onOptionChange={this.connection_type}
                                            isUpdateForm={this.props.fromUpdate}
                                            component={SelectInput}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="connection_port" className="requiredasterisk">Connection Port</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="connection_port"
                                            id="connection_port"
                                            component={renderField}
                                            validate={number}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="connection_username" className={this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'KasmVNC' ? 'requiredasterisk' : ''}>Connection Username</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="text"
                                            name="connection_username"
                                            id="connection_username"
                                            component={renderField}
                                            validate={this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'KasmVNC' ? required : null}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="connection_password" className={this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'KasmVNC' ? 'requiredasterisk' : ''}>Connection Password</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="connection_password"
                                            name="connection_password"
                                            id="connection_password"
                                            component={renderPass}
                                            validate={this.props.autoscaleFormValues && this.props.autoscaleFormValues.connection_type === 'KasmVNC' ? required : null}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="connection_info">Connection Info (JSON)</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="textarea"
                                            name="connection_info"
                                            id="connection_info"
                                            component={renderTextArea}
                                            validate={json}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="ad_create_machine_record">Create Active Directory Computer Record </Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="checkbox"
                                            name="ad_create_machine_record"
                                            id="ad_create_machine_record"
                                            checked={autoscaleFormValues && autoscaleFormValues.ad_create_machine_record}
                                            component={renderCheckbox}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            {autoscaleFormValues && autoscaleFormValues.ad_create_machine_record ?
                                <React.Fragment>
                                    <FormGroup style={{ 'padding-left': '20px' }}>
                                        <Row>
                                            <Col>
                                                <Label htmlFor="ldap_id" className="requiredasterisk">LDAP Config</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field name="ldap_id"
                                                    selectedValue={autoscaleFormValues.ldap_id}
                                                    options={optionsLdapConfigs}
                                                    isUpdateForm={this.props.fromUpdate}
                                                    validate={required}
                                                    component={SelectInput} />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup style={{ 'padding-left': '20px' }}>
                                        <Row>
                                            <Col>
                                                <Label htmlFor="ad_computer_container_dn" className="requiredasterisk">
                                                    Active Directory Computer OU DN
                                                </Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field type="text"
                                                    name="ad_computer_container_dn"
                                                    id="ad_computer_container_dn"
                                                    component={renderField}
                                                    validate={required}
                                                    placeholder="OU=KasmComputers,DC=example,DC=com"
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </React.Fragment>
                                :
                                ""
                            }
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="reusable" className="pull-left">Reusable</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Label check htmlFor="reusable">
                                            <Field name="reusable"
                                                id="reusable"
                                                checked={autoscaleFormValues && autoscaleFormValues.reusable}
                                                type="checkbox"
                                                component={renderCheckbox}
                                            />
                                        </Label>
                                    </Col>
                                </Row>
                            </FormGroup>

                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="minimum_pool_standby_sessions" className="requiredasterisk">Minimum Available Sessions</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="minimum_pool_standby_sessions"
                                            id="minimum_pool_standby_sessions"
                                            component={renderField}
                                            validate={number}
                                            placeholder="0"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="max_simultaneous_sessions_per_server" className="requiredasterisk">Max Simultaneous Sessions Per Server</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="max_simultaneous_sessions_per_server"
                                            id="max_simultaneous_sessions_per_server"
                                            component={renderField}
                                            disabled={this.state.disableMaxPerServer}
                                            validate={number}
                                            placeholder="1"
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </React.Fragment>
                    )}
                    {autoscaleFormValues && autoscaleFormValues.autoscale_type === "Docker Agent" && (
                        <React.Fragment>

                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="standby_cores" className="requiredasterisk">Standby Cores</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field
                                            type="number"
                                            name="standby_cores"
                                            id="standby_cores"
                                            component={renderField}
                                            validate={number}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="standby_gpus" className="requiredasterisk">Standby GPUs</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field
                                            type="number"
                                            name="standby_gpus"
                                            id="standby_gpus"
                                            component={renderField}
                                            validate={number}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="standby_memory_mb" className="requiredasterisk">Standby Memory (MB)</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field
                                            type="number"
                                            name="standby_memory_mb"
                                            id="standby_memory_mb"
                                            component={renderField}
                                            validate={number}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="standby_cores" className="requiredasterisk">Downscale Backoff (Seconds)</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field
                                            type="number"
                                            name="downscale_backoff"
                                            id="downscale_backoff"
                                            component={renderField}
                                            validate={number}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="agent_cores_override" className="requiredasterisk">Agent Cores Override</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="agent_cores_override"
                                            id="agent_cores_override"
                                            component={renderField}
                                            validate={number}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="agent_gpus_override" className="requiredasterisk">Agent GPUs Override</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="agent_gpus_override"
                                            id="agent_gpus_override"
                                            component={renderField}
                                            validate={number}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="agent_memory_override_gb" className="requiredasterisk">Agent Memory Override (GB)</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="number"
                                            name="agent_memory_override_gb"
                                            id="agent_memory_override_gb"
                                            component={renderField}
                                            validate={positive_float}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>


                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="nginx_cert" className="requiredasterisk">Nginx Cert</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="text"
                                            name="nginx_cert"
                                            id="nginx_cert"
                                            component={renderTextArea}
                                            validate={required}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="nginx_key" className="requiredasterisk">Nginx Key</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="text"
                                            name="nginx_key"
                                            id="nginx_key"
                                            component={renderTextArea}
                                            validate={required}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col>
                                        <Label htmlFor="register_dns">Register DNS</Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Field type="checkbox"
                                            name="register_dns"
                                            id="register_dns"
                                            onChange={(value) => this.props.onRegisterDns(value.target.checked)}
                                            checked={autoscaleFormValues && autoscaleFormValues.register_dns}
                                            component={renderCheckbox}
                                        />
                                    </Col>
                                </Row>
                            </FormGroup>
                            {autoscaleFormValues && autoscaleFormValues.register_dns ?
                                <React.Fragment>
                                    <FormGroup>
                                        <Row>
                                            <Col>
                                                <Label htmlFor="base_domain_name" className="requiredasterisk">Base
                                                    Domain Name</Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field type="text"
                                                    name="base_domain_name"
                                                    id="base_domain_name"
                                                    component={renderField}
                                                    validate={required}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>

                                </React.Fragment>
                                : ""}

                        </React.Fragment>
                    )}

                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm"
                            className="cancel-button"
                            color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit"
                            className="submit-button"
                            size="sm" color="primary">Next</Button>
                    </FormGroup>
                </CardFooter>

            </Form>
        );
    }
}

AutoScaleConfigFormTemplate.proptypes = {
    createAutoScaleConfig: Proptypes.func,
    updateAutoScaleConfig: Proptypes.func,
    fromUpdate: Proptypes.bool,
    zones: Proptypes.array,
    server_pools: Proptypes.array,
    vm_provider_configs: Proptypes.array,
    dns_provider_configs: Proptypes.array,
    ldap_configs: Proptypes.array,
    createServerPool: Proptypes.func.isRequired,
};

let AutoScaleConfigFormWithRouter = withRouter(AutoScaleConfigFormTemplate);


const selector = formValueSelector('AutoScaleConfigForm');

let AutoScaleConfigForm = connect(state => {

    const has_categorization_enabled = selector(state, 'enable_categorization');

    return {
        has_categorization_enabled,
        updateAutoScaleError: state.autoscale.updateAutoScaleError,
        updateAutoScaleLoading: state.autoscale.updateAutoScaleLoading,
        updatedAutoScale: state.autoscale.updatedAutoScale,
        autoscale_configs: state.autoscale.autoscale_configs,
        getAutoScaleLoading: state.autoscale.getAutoScaleLoading || false,
        license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
        autoscaleFormValues: state.form && state.form.AutoScaleConfigForm && state.form.AutoScaleConfigForm.values ? state.form.AutoScaleConfigForm.values : null,
        zones: state.zones.zones || [],
        server_pools: state.server_pools.server_pools || [],
        vm_provider_configs: state.vm_provider.vm_provider_configs || [],
        dns_provider_configs: state.dns_provider.dns_provider_configs || [],
        ldap_configs: state.ldap_configs.ldap_configs || [],
    }
},

    dispatch =>
    ({
        getAutoScaleConfigs: () => dispatch(getAutoScaleConfigs()),
        getLicenseStatus: () => dispatch(getLicenseStatus()),
        getVmProviderConfigs: () => dispatch(getVmProviderConfigs()),
        getDnsProviderConfigs: () => dispatch(getDnsProviderConfigs()),
        getZones: () => dispatch(getZones()),
        getServerPools: () => dispatch(getServerPools()),
        getLdap: () => dispatch(getLdap()),
        createServerPool: (data) => dispatch(createServerPool(data)),

    }))(AutoScaleConfigFormWithRouter);

export default reduxForm({
    form: "AutoScaleConfigForm",
})(AutoScaleConfigForm);